export default __webpack_public_path__ + "static/media/step2_img1.a8a356ef.png";